export interface AvatarProps {
  name: string;
  size?: number;
  src?: string;
}

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/** Circular avatar: image if provided, else warm-toned initials. */
export function Avatar({ name, size = 36, src }: AvatarProps) {
  if (src) {
    return (
      <img
        src={src}
        alt={name}
        width={size}
        height={size}
        style={{ borderRadius: "50%", objectFit: "cover" }}
      />
    );
  }
  return (
    <div
      aria-label={name}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: "var(--color-primary-soft)",
        // Use text (not primary) so initials stay readable on soft brand
        // surfaces in dark mode — primary-on-primary-soft failed WCAG there.
        color: "var(--color-text)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "var(--font-weight-bold)",
        fontSize: size * 0.4,
        flexShrink: 0,
      }}
    >
      {initialsOf(name)}
    </div>
  );
}
